import { render, staticRenderFns } from "./processPage.vue?vue&type=template&id=35764796&"
import script from "./processPage.vue?vue&type=script&lang=js&"
export * from "./processPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports